export function contentHasErrored(bool) {
    return {
        type: 'CONTENT_HAS_ERRORED',
        contentHasErrored: bool
    };
}

export function contentIsLoading(bool) {
    return {
        type: 'CONTENT_IS_LOADING',
        contentIsLoading: bool
    };
}

export function contentFetchSuccess(content) {
    return {
        type: 'CONTENT_FETCH_SUCCESS',
        content
    };
}

export function fetchContent(url, lastUpdated, webkey) {
    return (dispatch) => {
        let now = new Date();
        let rev = now.getTime()/1000;
        if (url.includes('?')){
            url+="&rev="+rev
        }
        else{
            url+="?rev="+rev
        }
        if (webkey){
            url+="&webkey="+webkey
        }
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((content) => {
                if (Number(content.last_update)>Number(lastUpdated)){
                    dispatch(contentFetchSuccess(content))    
                }
                else{
                    return null;
                }
            }).catch(() => {
                dispatch(contentHasErrored(true));   
            });
    };
}

export function fetchModuleContent(url, webkey) {
    return (dispatch) => {
        if (webkey){
            url+="&webkey="+webkey
        }
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((content) => {
                dispatch(contentFetchSuccess(content));
            }).catch(() => {
                dispatch(contentHasErrored(true));
            });
    };
}


// WEBPACK FOOTER //
// ./src/actions/content.js